export default "__VITE_ASSET__CYW7aJMu__"